import React from 'react';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import { ThemeProvider } from '@mui/material/styles';
import { Theme } from './components/MuiTheme/Theme';
import { PrimeReactProvider } from 'primereact/api';
import {store, persistor} from '@Redux/store';
import ErrorFallBack from './ErrorFallBack';
import { ErrorBoundary } from 'react-error-boundary';
import GlobalSnackbar from '@CommonFunctionalDisplay/GlobalSnackbar';
import Routes from './Routes/Routes';
import 'typeface-roboto';
import AlertTemplate from 'react-alert-template-basic';
import './index.scss';

const options = {
    position: positions.MIDDLE,
    timeout: 5000,
    transition: transitions.SCALE
}

// Legacy URL backward compatibility
// Old form URL: /?type=form&subType=report&formId=APQKZQ12345 → /#/report/APQKZQ12345
// Old ticket URL: /?type=ticket&subType=track&email=...&ticketId=... → /#/home/track?...
const legacyParams = new URLSearchParams(window.location.search);
const legacyType = legacyParams.get('type');
const legacySubType = legacyParams.get('subType');
if (legacyType === 'form' && legacySubType === 'report') {
    const legacyFormId = legacyParams.get('formId');
    if (legacyFormId) {
        window.location.replace(window.location.pathname + '#/report/' + legacyFormId);
    }
} else if (legacyType === 'ticket' && legacySubType === 'track') {
    const email = legacyParams.get('email');
    const ticketId = legacyParams.get('ticketId');
    if (email && ticketId) {
        const newParams = new URLSearchParams({ type: 'ticket', subType: 'track', email, ticketId });
        const trackingId = legacyParams.get('trackingId');
        const formId = legacyParams.get('formId');
        if (trackingId) newParams.set('trackingId', trackingId);
        if (formId) newParams.set('formId', formId);
        window.location.replace(window.location.pathname + '#/home/track?' + newParams.toString());
    }
}

render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <PrimeReactProvider>
                    <AlertProvider template={AlertTemplate} {...options}>
                        <ThemeProvider theme={Theme}>
                            <HelmetProvider>
                            <ErrorBoundary FallbackComponent={ErrorFallBack}>
                                <GlobalSnackbar />
                                    <RouterProvider router={Routes} />
                            </ErrorBoundary>
                            </HelmetProvider>
                        </ThemeProvider>
                    </AlertProvider>
                </PrimeReactProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

reportWebVitals();
